import {Controller, useFormContext} from "react-hook-form";
import {LiveEventAttendeesFormFieldsType} from "../types";
import {Input, Space} from "antd";
import {FormFieldError} from "../../../../../design-system/form-field";

export function LiveEventAttendeesFormField() {
  const {watch, control} = useFormContext<LiveEventAttendeesFormFieldsType>();
  const isLimitedAttendeesSelected = watch("attendeesType") === "limited";

  return (
    <div>
      {isLimitedAttendeesSelected && (
        <Controller
          control={control}
          name="attendees"
          render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
            <Space size={16} direction="vertical" style={{display: "flex"}}>
              <Input
                status={error?.message ? "error" : ""}
                onChange={onChange}
                onBlur={onBlur}
                size="large"
                value={value === null ? undefined : value}
                placeholder="Enter a number"
                ref={ref}
              />
              <FormFieldError errorMessage={error?.message} />
            </Space>
          )}
        />
      )}
    </div>
  );
}
